import { useSelector } from "react-redux";
// Components
import CommonTopsection from "../../components/TopSection";
import ErrorBoundary from "../../components/ErrorBoundary";
// import MsaPopup from "../../components/MsaAgreement/MsaPopup";
// utils
import TableSection from "./TableSection";
import SmallDougnutTable from "../../components/TopSection/SmallDougnutTable";
import Heading from "../../components/Heading";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import ChatbotWidget from "../../components/Chatbot/ChatbotWidget"

const TestDashboard = () => {
  const { kpis } = useSelector((state) => state.dashboard);
  const { loanCount, status } = kpis;

  const componentConfig = [
    {
      component: (
        <Heading
          className="col-sm-12"
          text="My Dashboard"
          showMarquee={loanCount === 0 && status === "fulfilled" ? true : false}
        />
      ),
      // role: ["Both"],
      className: "col-sm-12 px-4",
    },
    // {
    //   component: <CommonTopsection className="col-sm-12" />,
    //   // role: ["Both"],
    //   className: "col-sm-12 px-4 mb-5",
    // },
    // {
    //   component: <SmallDougnutTable className="col-sm-12" />,
    //   // role: ["Both"],
    //   className:
    //     "col-xl-12 col-lg-12 py-0 mb-5 px-4 portfolio-balance-upcoming-payments",
    // },
    // {
    //   component: <TableSection className="col-sm-12" />,
    //   // role: ["Both"],
    //   className: "col-sm-12",
    // },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          {/* <DynamicComponentRenderer componentConfig={componentConfig} /> */}
        </article>
      </section>
      <ChatbotWidget />
    </div>
  );
};
export default TestDashboard;
